export const ShipmentsEndpoint = (makeRequest) => {
    return {
        calculateShipments(params, options) {
            return makeRequest('GET', '/v1/scheduling/shipments/calculate_shipments', params, options);
        },
    };
};
//# sourceMappingURL=shipments_endpoint.js.map